module.exports = __webpack_public_path__ + "img/ch33.10d48712.jpg";